import React from 'react'
import { BrowserRouter as Router, Routes,Route, Outlet} from "react-router-dom";
import { Navigate } from 'react-router-dom';

//main 
import InputLoginPage from '../../Caisse/loginPage'
import InputLandingPage from '../../Caisse/caisseLandingPage'
import UploadeCamionPage from '../../Caisse/Upload/updatePage';
import GConf from '../generalConf';

//Caisses
import CaisseSimple from "../../Caisse/Caisse/caisseSimple"; 
 

//Factures
import MesFactures from '../../Caisse/Factures/mesFactures';
import FactureInfo from '../../Caisse/Factures/factureInfo';
 

//Factures
import Commandes from '../../Caisse/Commandes/mesFactures';
import CommandeInfo from '../../Caisse/Commandes/factureInfo';
 


//Recette
import ImprimerRecette from '../../Caisse/Recette/imprimerRecette';
 




const RedirectingPage = () => {
    const CamionIsLogged = localStorage.getItem(`Magazin_Caisse_LocalD`);
    return (<>
        {
            CamionIsLogged ? <Navigate to='/C/L'  /> : <Navigate to='/C/logIn'  />
        } 
</>);}

const caisseRouter = () => (
    <Route path="C" exact element={<Outlet />} >
            <Route path="" exact element={<RedirectingPage />} />
            <Route path="logIn" exact element={<InputLoginPage />} />
            <Route path="L" exact element={<Outlet />} >
                    <Route path="" exact element={<InputLandingPage />} />
                    
                    <Route path="nv" exact element={<CaisseSimple />} />
                     
                    
                    <Route path="ft" exact element={<Outlet />} >
                        <Route path="" exact element={<MesFactures />} />
                        <Route path="info/:FID" exact element={<FactureInfo />} />
                    </Route>

                    <Route path="cd" exact element={<Outlet />} >
                        <Route path="" exact element={<Commandes />} />
                        <Route path="info/:CID" exact element={<CommandeInfo />} />
                         
                    </Route>

                    <Route path="recette" exact element={<ImprimerRecette />} />

                    <Route path="up" exact element={<UploadeCamionPage />} />
            </Route>
    </Route>
)

export default caisseRouter 